export const VOLT = "#00F0FF";

export type Category = "Wszystkie" | "Przemysł" | "Smart Home" | "Rozdzielnice" | "Pomiary" | "CCTV";

export type GalleryItem = {
  img: string;
  title: string;
  desc: string;
  date: string;
  location: string;
  category: Exclude<Category, "Wszystkie">;
  span?: "tall" | "wide";
  featured?: boolean;
};

export const GALLERY: GalleryItem[] = [
  {
    img: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?auto=format&fit=crop&w=480&q=70",
    title: "Prefabrykacja szafy 2500A",
    desc: "Szafa sterownicza dla hali logistycznej. Aparatura Eaton, pełne uziemienie, pomiary p.porażeniowe.",
    date: "06.2026",
    location: "Katowice",
    category: "Rozdzielnice",
    span: "tall",
    featured: true,
  },
  {
    img: "https://images.unsplash.com/photo-1581092335397-9583eb92d232?auto=format&fit=crop&w=480&q=70",
    title: "Modernizacja zasilania hali",
    desc: "Wymiana rozdzielnicy głównej n/n, nowe trasy kablowe, LED hali, pomiary odbiorcze.",
    date: "04.2026",
    location: "Mikołów",
    category: "Przemysł",
    span: "wide",
    featured: true,
  },
  {
    img: "https://images.unsplash.com/photo-1558002038-1055907df827?auto=format&fit=crop&w=480&q=70",
    title: "Smart Home Fibaro 180 m²",
    desc: "Automatyka oświetlenia, rolet i ogrzewania. Integracja z Satel oraz monitoringiem HQVision.",
    date: "03.2026",
    location: "Bytom",
    category: "Smart Home",
    featured: true,
  },
  {
    img: "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?auto=format&fit=crop&w=480&q=70",
    title: "Pomiary 5-letnie wspólnoty",
    desc: "Cykliczne pomiary p.porażeniowe. Pełna dokumentacja zgodna z PN-HD 60364.",
    date: "02.2026",
    location: "Tarnowskie Góry",
    category: "Pomiary",
  },
  {
    img: "https://images.unsplash.com/photo-1573164574511-73c773193279?auto=format&fit=crop&w=480&q=70",
    title: "Monitoring HQVision 4K",
    desc: "16 kamer IP, NVR, sieć światłowodowa, integracja z kontrolą dostępu.",
    date: "01.2026",
    location: "Gliwice",
    category: "CCTV",
    span: "wide",
    featured: true,
  },
  {
    img: "https://images.unsplash.com/photo-1521133573892-e44906baee46?auto=format&fit=crop&w=480&q=70",
    title: "Ochrona odgromowa LPS",
    desc: "Zwody poziome, przewody odprowadzające, uziom otokowy. Pomiary kontrolne.",
    date: "12.2025",
    location: "Ruda Śląska",
    category: "Pomiary",
    span: "tall",
  },
  {
    img: "https://images.unsplash.com/photo-1565608438257-fac3c27beb36?auto=format&fit=crop&w=480&q=70",
    title: "Rozdzielnica zasilania awaryjnego",
    desc: "Układ SZR z generatorem 150 kW. Pełna automatyka przełączania.",
    date: "11.2025",
    location: "Zabrze",
    category: "Rozdzielnice",
  },
  {
    img: "https://images.unsplash.com/photo-1597138804456-e7dca7f59d54?auto=format&fit=crop&w=480&q=70",
    title: "Smart Home xComfort apartament",
    desc: "Sceny świetlne, sterowanie roletami, integracja z HVAC i głośnikami.",
    date: "10.2025",
    location: "Bytom",
    category: "Smart Home",
  },
  {
    img: "https://images.unsplash.com/photo-1605152276897-4f618f831968?auto=format&fit=crop&w=480&q=70",
    title: "Trasy kablowe hali produkcyjnej",
    desc: "Kompleksowe trasy korytek, podłączenia maszyn, oznakowanie obwodów.",
    date: "09.2025",
    location: "Tarnowskie Góry",
    category: "Przemysł",
  },
];

export const CATEGORIES: Category[] = ["Wszystkie", "Przemysł", "Smart Home", "Rozdzielnice", "Pomiary", "CCTV"];

export const FEATURED = GALLERY.filter((g) => g.featured);